import React, { FunctionComponent, useEffect, useState } from 'react';
import {
  MenuButton,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuOpenChangeData,
} from '@fluentui/react-components';
import { ChevronDownFilled } from '@fluentui/react-icons';
import { ScopeTrail } from './components/scope-trail';
import { useFocusedEntityContext } from './focused-entity-context';
import { withEntitySearch } from './with-entity-search';
import { useScopeBarStyles } from './styles';
import { Entity } from './types';

export interface IScopeSelectorDropdownProps {
  entityList: Entity[];
  popoverContent: React.ReactNode;
  i18n: { getString: (key: string, params?: any) => string };
  rootEntityTypeDisplayName: string;
  selectedEntity?: Entity;
}

const ScopeSelectorDropdown: FunctionComponent<IScopeSelectorDropdownProps> = (props) => {
  const {
    popoverContent,
    ...rest
  } = props;

  const [popoverOpen, setPopoverOpen] = useState(false);
  const { focusedEntity, setFocusedEntity } = useFocusedEntityContext();

  const styles = useScopeBarStyles();

  const handleMenuOpenChange = (e, data: MenuOpenChangeData): void => {
    setPopoverOpen(data.open);
    if (!data.open) {
      setFocusedEntity(undefined);
    }
  };

  useEffect(() => {
    if (!popoverOpen && focusedEntity) {
      setFocusedEntity(undefined);
    }
  }, [focusedEntity, popoverOpen, setFocusedEntity]);

  return (
    <Menu
      open={popoverOpen}
      onOpenChange={handleMenuOpenChange}
    >
      <MenuTrigger disableButtonEnhancement>
        <MenuButton
          appearance="subtle"
          menuIcon={<ChevronDownFilled className={styles.dropdownMenuIcon} />}
          className="scope-selector-dropdown"
        >
          <ScopeTrail {...rest} />
        </MenuButton>
      </MenuTrigger>
      <MenuPopover>
        {React.isValidElement(popoverContent) && React.cloneElement(popoverContent as React.ReactElement, { setPopoverOpen })}
      </MenuPopover>
    </Menu>
  );
};

ScopeSelectorDropdown.defaultProps = {
  selectedEntity: undefined,
};

const ScopeSelectorDropdownWithSearch = withEntitySearch<IScopeSelectorDropdownProps>(ScopeSelectorDropdown);

export { ScopeSelectorDropdownWithSearch as ScopeSelectorDropdown };
